import React from "react";
import ContentLoader from "react-content-loader";
import { Container } from "./styles";
import { HiOutlineSwitchHorizontal, HiOutlineDocumentText, HiOutlineIdentification } from "react-icons/hi";
import { BiSpreadsheet, BiBuildings } from "react-icons/bi";
import { FiFilter, FiX, FiDownload, FiCalendar, FiHash, FiKey, FiCheckCircle } from "react-icons/fi";
import { MdSearch, MdFileDownload } from "react-icons/md";

const TransactionsLoadingSkeleton = ({ isDark = true }) => {
  const backgroundColor = isDark ? "#1a1a1a" : "#f0f0f0";
  const foregroundColor = isDark ? "#2a2a2a" : "#e5e7eb";

  return (
    <Container>
      {/* Header - mantém como está */}
      <div className="header-info">
        <div className="header-icon">
          <HiOutlineSwitchHorizontal />
        </div>
        <div className="header-details">
          <h3>Dashboard de Movimentações</h3>
          <div className="header-meta">
            <span className="status-tag active">Sistema Online</span>
            <span className="update-tag">Carregando...</span>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="tabs-header">
        <button className="tab active">
          <BiSpreadsheet />
          Relatórios
        </button>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "0.8em", margin: 0, padding: 0 }}>
        {/* Metric Cards - 5 cards */}
        <div className="metric-cards" style={{ margin: 0, padding: 0 }}>
          {["blue", "green", "purple", "orange", "red"].map((color, i) => (
            <div key={`metric-${i}`} className={`metric-card ${color}`}>
              <div className={`metric-icon ${color}`}>
                <ContentLoader
                  speed={2}
                  width={24}
                  height={24}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="0" y="0" rx="4" ry="4" width="24" height="24" />
                </ContentLoader>
              </div>
              <div className="metric-content">
                <span className="metric-value">
                  <ContentLoader
                    speed={2}
                    width={50}
                    height={24}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="50" height="24" />
                  </ContentLoader>
                </span>
                <span className="metric-label">
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={13}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="80" height="13" />
                  </ContentLoader>
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Toolbar */}
        <div className="toolbar" style={{ margin: 0, marginBottom: "0.8em" }}>
          <div className="toolbar-left">
            <button className="toolbar-btn">
              <FiFilter />
              Filtro Relatórios
            </button>
            <button className="toolbar-btn">
              <FiX />
              Limpar Filtros
            </button>
            <div className="search-box">
              <MdSearch />
              <ContentLoader
                speed={2}
                width={250}
                height={14}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width="250" height="14" />
              </ContentLoader>
            </div>
            <span className="docs-count">
              <ContentLoader
                speed={2}
                width={60}
                height={13}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width="60" height="13" />
              </ContentLoader>
            </span>
          </div>

          <div className="toolbar-right">
            <button className="toolbar-btn">
              <FiDownload />
              Download XMLs
            </button>
            <button className="toolbar-btn">
              <FiDownload />
              Download TXT
            </button>
            <button className="toolbar-btn">
              <MdFileDownload />
              Download PDF
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="table-container">
          {/* Table Header */}
          <div className="table-header">
            <div className="header-cell col-dot"></div>
            <div className="header-cell col-data">
              <FiCalendar /> Data
            </div>
            <div className="header-cell col-numero">
              <FiHash /> Número NFE
            </div>
            <div className="header-cell col-chave">
              <FiKey /> Chave
            </div>
            <div className="header-cell col-status">
              <FiCheckCircle /> Status
            </div>
            <div className="header-cell col-cnpj">
              <HiOutlineIdentification /> CNPJ
            </div>
            <div className="header-cell col-emitente">
              <BiBuildings /> Emitente
            </div>
            <div className="header-cell col-actions"></div>
          </div>

          {/* Table Body - 10 rows */}
          <div className="table-body">
            {[...Array(10)].map((_, i) => (
              <div className="table-row" key={`row-${i}`} style={{ position: "relative" }}>
                <div className="cell col-dot">
                  <span className={`dot ${i % 2 === 0 ? "green" : "blue"}`}></span>
                </div>
                <div className="cell col-data">
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={13}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="80" height="13" />
                  </ContentLoader>
                </div>
                <div className="cell col-numero">
                  <ContentLoader
                    speed={2}
                    width={70}
                    height={13}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="70" height="13" />
                  </ContentLoader>
                </div>
                <div className="cell col-chave">
                  <ContentLoader
                    speed={2}
                    width={200}
                    height={13}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="200" height="13" />
                  </ContentLoader>
                </div>
                <div className="cell col-status">
                  <span className="status-badge authorized">
                    <ContentLoader
                      speed={2}
                      width={80}
                      height={11}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="80" height="11" />
                    </ContentLoader>
                  </span>
                </div>
                <div className="cell col-cnpj">
                  <ContentLoader
                    speed={2}
                    width={140}
                    height={13}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="140" height="13" />
                  </ContentLoader>
                </div>
                <div className="cell col-emitente">
                  <ContentLoader
                    speed={2}
                    width={180}
                    height={13}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="180" height="13" />
                  </ContentLoader>
                </div>
                <button
                  className="action-btn"
                  style={{ 
                    position: "absolute", 
                    right: 0, 
                    marginRight: "2em",
                    background: "transparent",
                    border: "none",
                    opacity: 0.3,
                    cursor: "default"
                  }}
                >
                  <ContentLoader
                    speed={2}
                    width={16}
                    height={16}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="2" ry="2" width="16" height="16" />
                  </ContentLoader>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default TransactionsLoadingSkeleton;
